import { Slider } from '@sparemin/blockhead';
import React from 'react';
import BemCSSTransition from 'components/BemCssTransition';
import ClipSelectPlayerDuration from './ClipSelectPlayerDuration';
import { useClipSelectVideoPlayerAnimation } from './ClipSelectVideoPlayerAnimationContext';
import { basePlayerBlock as block } from './utils';

export type ClipSelectPlayerPlaybarProps = {
  duration: number;
  currentTime: number;
  onChange: (value: number) => void;
  maxValue: number;
};

const ClipSelectPlayerPlaybar: React.FC<ClipSelectPlayerPlaybarProps> = ({
  duration,
  currentTime,
  onChange,
  maxValue,
}) => {
  const animations = useClipSelectVideoPlayerAnimation();
  return (
    <div className={block('progress-bar-with-duration')}>
      <BemCSSTransition
        className={block('progress-bar-row')}
        {...animations.progressBarRow}
      >
        <div>
          <div className={block('duration-tag-row')}>
            <div className={block('duration-tag-spacer')} />
            <ClipSelectPlayerDuration
              currentTime={currentTime}
              duration={duration}
            />
          </div>
          <BemCSSTransition
            className={block('progress')}
            {...animations.progress}
          >
            <div>
              <Slider
                className={block('progress-slider')}
                value={currentTime}
                maxValue={maxValue}
                minValue={0}
                step={0.01}
                onChange={onChange}
                aria-label="Video progress"
              />
            </div>
          </BemCSSTransition>
        </div>
      </BemCSSTransition>
    </div>
  );
};

export default ClipSelectPlayerPlaybar;
